import { CommonStorage } from "../_services/storage";

export const ui = {
  namespaced: true,
  state: {
    toolBarHeight: null,
    headerHeight: null,
    viewHeight: null,
    gridHeight: null,
    checkGridNoData: false,
    headerFormHeight: undefined,
    gridFooterHeight: 0,
    gridExpand: false,
    ignoreRouteChange: false,
    updateIsDefault: false,
    updateIsDefaultCode: undefined,
    viewRouted: false,
    updateGridOnDefault: false,
    commentPopUpItems: undefined,
    goBackRoute: undefined,
    serverError: undefined,
    updateIsDefaultEvent: undefined,
    transactionCommentPopUp: false,
    validationSummaryVisible: false,
    visibleCommentLabels: true,
    apiVersionUpdate: false,
    uiVersionUpdate: false,
    gridContentReady: false,
    isSubmitting: false,
    visibleGridSavePopup: false,
  },
  actions: {
    setIsSubmitting({ commit }, value) {
      commit("isSubmitting", value);
    },
    setGridContentReady({ commit }, message) {
      commit("gridContentReady", message);
    },
    uiVersionUpdate({ commit }, message) {
      commit("uiVersionUpdate", message);
    },
    apiVersionUpdate({ commit }, message) {
      commit("apiVersionUpdate", message);
    },
    toolBarHeight({ commit }, message) {
      commit("toolBarHeight", message);
    },
    headerHeight({ commit }, message) {
      commit("headerHeight", message);
    },
    viewHeight({ commit }, message) {
      commit("viewHeight", message);
    },
    gridHeight({ commit }, message) {
      commit("gridHeight", message);
    },
    checkGridNoData({ commit }, message) {
      commit("checkGridNoData", message);
    },
    headerFormHeight({ commit }, message) {
      commit("headerFormHeight", message);
    },
    setGridFooterHeight({ commit }, message) {
      commit("gridFooterHeight", message);
    },
    setGridExpand({ commit }, message) {
      commit("gridExpand", message);
    },
    setIgnoreRouteChange({ commit }, message) {
      commit("ignoreRouteChange", message);
    },
    setUpdateIsDefault({ commit }, message) {
      commit("updateIsDefault", message);
    },
    setViewRouted({ commit }, message) {
      commit("viewRouted", message);
    },
    setUpdateGridOnDefault({ commit }, message) {
      commit("updateGridOnDefault", message);
    },
    setCommentPopUpItems({ commit }, message) {
      commit("commentPopUpItems", message);
    },
    setGoBackRoute({ commit }, message) {
      commit("goBackRoute", message);
    },
    setServerError({ commit }, message) {
      commit("serverError", message);
    },
    setTransactionCommentPopUp({ commit }, message) {
      commit("transactionCommentPopUp", message);
    },
    setValidationSummaryVisible({ commit }, message) {
      commit("validationSummaryVisible", message);
    },
    setVisibleCommentLabels({ commit }, message) {
      commit("visibleCommentLabels", message);
    },
    setVisibleGridSavePopup({ commit }, message) {
      commit("visibleGridSavePopup", message);
    },
  },
  mutations: {
    isSubmitting(state, value) {
      state.isSubmitting = value;
    },
    gridContentReady(state, message) {
      state.gridContentReady = message;
    },
    uiVersionUpdate(state, message) {
      state.uiVersionUpdate = message;
    },
    apiVersionUpdate(state, message) {
      state.apiVersionUpdate = message;
    },
    toolBarHeight(state, message) {
      state.toolBarHeight = message;
    },
    headerHeight(state, message) {
      state.headerHeight = message;
    },
    viewHeight(state, message) {
      state.viewHeight = message;
    },
    gridHeight(state, message) {
      state.gridHeight = message;
    },
    checkGridNoData(state, message) {
      state.checkGridNoData = message;
    },
    headerFormHeight(state, message) {
      state.headerFormHeight = message;
    },
    gridFooterHeight(state, message) {
      state.gridFooterHeight = message;
    },
    gridExpand(state, message) {
      state.gridExpand = message;
    },
    ignoreRouteChange(state, message) {
      state.ignoreRouteChange = message;
    },
    updateIsDefault(state, message) {
      state.updateIsDefault = message.update;
      state.updateIsDefaultCode = message.code;
      if (message.event) state.updateIsDefaultEvent = message.event;
    },
    viewRouted(state, message) {
      state.viewRouted = message;
    },
    updateGridOnDefault(state, message) {
      state.updateGridOnDefault = message;
    },
    commentPopUpItems(state, message) {
      state.commentPopUpItems = message;
    },
    goBackRoute(state, message) {
      state.goBackRoute = message;
    },
    serverError(state, message) {
      state.serverError = message;
    },
    transactionCommentPopUp(state, message) {
      state.transactionCommentPopUp = message;
    },
    validationSummaryVisible(state, message) {
      state.validationSummaryVisible = message;
    },
    visibleCommentLabels(state, message) {
      state.visibleCommentLabels = message;
    },
    visibleGridSavePopup(state, message) {
      state.visibleGridSavePopup = message;
    }
  },
  getters: {
    getGridContentReady(state) {
      return state.gridContentReady;
    },
    getUiVersionUpdate(state) {
      return state.uiVersionUpdate;
    },
    getApiVersionUpdate(state) {
      return state.apiVersionUpdate;
    },
    getToolBarHeight(state) {
      return state.toolBarHeight;
    },
    getHeaderHeight(state) {
      return state.headerHeight;
    },
    getHeightForDataGrid(state) {
      if (state.gridHeight != null) {
        return state.gridHeight;
      } else if (
        state.toolBarHeight != null &&
        state.headerHeight != null &&
        state.viewHeight != null
      ) {
        return state.viewHeight; // - state.gridFooterHeight;
      } else {
        return null;
      }
    },
    getCheckGridNoData(state) {
      return state.checkGridNoData;
    },
    getHeaderFormHeight(state) {
      return state.headerFormHeight;
    },
    getGridExpand(state) {
      return state.gridExpand;
    },
    getIgnoreRouteChange(state) {
      return state.ignoreRouteChange;
    },
    getUpdateIsDefault(state) {
      return state.updateIsDefault;
    },
    getUpdateIsDefaultCode(state) {
      return state.updateIsDefaultCode;
    },
    getHeigthForForm(state) {
      return state.viewHeight;
    },
    getViewRouted(state) {
      return state.viewRouted;
    },
    getUpdateGridOnDefault(state) {
      return state.updateGridOnDefault;
    },
    getCommentPopUpItems(state) {
      return state.commentPopUpItems;
    },
    getGoBackRoute(state) {
      return state.goBackRoute;
    },
    getServerError(state) {
      return state.serverError;
    },
    getUpdateIsDefaultEvent(state) {
      return state.updateIsDefaultEvent;
    },
    getTransactionCommentPopUp(state) {
      return state.transactionCommentPopUp;
    },
    getValidationSummaryVisible(state) {
      return state.validationSummaryVisible;
    },
    getVisibleCommentLabels(state) {
      return state.visibleCommentLabels;
    },
    getAPIVersion() {
      return CommonStorage.getItems("CUSTOMER_PREFIX_API_VERSION");
    },
    getUIVersion() {
      return CommonStorage.getItems("CUSTOMER_PREFIX_UI_VERSION");
    },
    getVisibleGridSavePopup(state) {
      return state.visibleGridSavePopup;
    },
  },
};
